import { api, type ApiEnvelope } from './api';
import type { StoreSettings } from '../types';

export const settingsService = {
  async get() {
    const { data } = await api.get<ApiEnvelope<StoreSettings>>('/settings');
    return data.data;
  },
};
